export default __webpack_public_path__ + "static/media/contract_icon.f31c71d2.svg";